import { FlowNotableObject, FlowUpdateNotableObjectConfigSchema } from 'flow-schema';

import { type api } from 'common';

import { UpdateNotableObjectFormFields } from './FormFields';
import { UpdateNotableObjectOutputContent } from './OutputContent';
import { UpdateNotableObjectDocumentationMarkdown } from './documentation';
import { type BlockConfigProps } from '../../types';

export const updateNotableObjectConfig: BlockConfigProps<
  api.FlowDefinition.UpdateNotableObjectBlock['config']
> = {
  nodeHandles: [{ type: 'target' }, { type: 'source' }],
  defaultLabelPrefix: 'UpdateNotableObject',
  defaultConfig: {
    notableObject: FlowNotableObject.Patient,
    payload: '',
  },
  configFields: {
    schema: FlowUpdateNotableObjectConfigSchema,
    FormFields: UpdateNotableObjectFormFields,
  },
  OutputContentComponent: UpdateNotableObjectOutputContent,
  documentationMarkdown: UpdateNotableObjectDocumentationMarkdown,
};
